export const environment = {
    production: true,
    apiUrl: '',
    ssrDistBrowserFolder: 'wwwroot',
    startPage: '',
    snowplow: {
        defaultEndpoint: 'https://c.universal-robots.com',
        zhHansEndpoint: 'https://c.universal-robots.cn',
    },
};
